// Debounced duplicate-detection hook used by the New / Edit forms.
//
//   const { candidates, checking } = useSimilarCheck(
//     { title: form.title, year: form.year, excludeId: initialValue?.id },
//     findSimilarBibliography,
//   );
//
// The probe is JSON-stringified to derive a stable dependency, so the
// hook only re-queries when the *contents* of the probe change (not on
// every parent re-render that happens to produce a new object literal).
// The query is debounced 500 ms so we don't hammer Postgres on each
// keystroke, and the request is cancelled if the probe changes again
// before it returns.

import { useEffect, useState } from 'react';

export function useSimilarCheck(probe, finder, delay = 500) {
  const [candidates, setCandidates] = useState([]);
  const [checking, setChecking] = useState(false);

  // Stable dep: the *value* of the probe, not the reference. Without
  // this, every parent re-render that produced a new `{ title }` object
  // literal would re-fire the effect even if the title hadn't changed.
  const probeKey = JSON.stringify(probe);

  useEffect(() => {
    let cancelled = false;
    setChecking(true);
    const timer = setTimeout(async () => {
      const rows = await finder(probe);
      if (!cancelled) {
        setCandidates(rows);
        setChecking(false);
      }
    }, delay);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
    // probe is captured for the API call; we deliberately key the effect
    // on probeKey only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [probeKey, delay]);

  return { candidates, checking };
}
